import { AfterViewInit, Directive } from '@angular/core';
import { Observable } from 'rxjs';
import { AutoUnsubscribe } from '../../../decorators';
import { ListServerPaginationStateModel, ListRange } from '../../../models';
import { DEFAULT_PAGE_SIZE } from '../../../constants/table-config';
import { List } from './list';
import { TranslateService } from '@ngx-translate/core';

@Directive()
@AutoUnsubscribe
export abstract class ListServerPagination<BriefType> extends List<BriefType> implements AfterViewInit {
  abstract listDto$: Observable<ListServerPaginationStateModel<BriefType>>;
  initialFetch = true;

  protected constructor(translateService: TranslateService) {
    super(translateService);
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.fetchListOnPaginatorChanges();

    if (this.initialFetch) {
      this.fetchList({ page: 0, size: DEFAULT_PAGE_SIZE });
    }
  }

  protected abstract fetchList(listRange: ListRange): void;

  private fetchListOnPaginatorChanges(): void {
    this.subscriptions.push(
      this.paginator.page.subscribe(({ pageIndex: page, pageSize: size }: { pageIndex: number; pageSize: number }) => {
        this.fetchList({
          page,
          size,
        });
      }),
    );
  }
}
